import Box from '@components/Box';
import TextInputContainer from '@containers/TextInputContainer';
import WrapperDetails from './WrapperDetails';
import { Grid, Row } from '@components/Grid';
import { TProfilePartnerCodeForm } from './../types';
import { AccountPromoType } from '@api/Responses/AccountResponse';
import { linkPromoToAccount } from '@api/apiClient';
import { getPromo } from '@api/apiClient/signUp';
import { getErrorMessage } from '@utils/errorMessage';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useProfile } from '@contexts/ProfileContext';
import { useTranslation } from 'react-i18next';

// Код партнёра — промо типа FbpPickUpReferral. Раньше вводился в форме заявки на пикап,
// теперь — здесь, чтобы указать его мог любой селлер. Привязать можно только один раз.
const PARTNER_PROMO_TYPE: AccountPromoType = 'FbpPickUpReferral';
const ERROR_PREFIX = 'profileData.partnerCode.errors';

const PartnerCodeDetails: React.FC = (): React.ReactElement => {
  const { account, get } = useProfile();
  const { t } = useTranslation();

  const linkedPromo = account?.promos?.find((promo) => promo.promoType === PARTNER_PROMO_TYPE);

  const { control, formState, handleSubmit, reset } = useForm<TProfilePartnerCodeForm>({
    defaultValues: {
      partnerCode: linkedPromo?.code ?? ''
    }
  });

  useEffect(() => {
    reset({ partnerCode: linkedPromo?.code ?? '' });
  }, [linkedPromo?.code, reset]);

  const {
    error: errorLinkPromo,
    isError: isErrorLinkPromo,
    isLoading: isLoadingLinkPromo,
    mutate: mutateLinkPromo,
    reset: resetLinkPromo
  } = useMutation({
    mutationFn: async (form: TProfilePartnerCodeForm) => {
      // Селлер вводит код (имя промо), а бэкенд привязывает по id — сначала находим промо по коду.
      const promo = await getPromo('', form.partnerCode.trim());
      if (promo.promoType !== PARTNER_PROMO_TYPE) {
        throw t(`${ERROR_PREFIX}.promo-not-found`);
      }
      await linkPromoToAccount({ promoId: promo.id });
    },
    onSuccess: () => {
      get();
    }
  });

  // По макету ошибка показывается под полем, а не рядом с кнопкой (поэтому WrapperDetails её не рисует).
  const errorMessage = isErrorLinkPromo
    ? getErrorMessage({ errorPrefix: ERROR_PREFIX, error: errorLinkPromo, t })
    : undefined;

  return (
      <WrapperDetails
          btnAction={() => {
            handleSubmit((form) => mutateLinkPromo(form))();
            resetLinkPromo();
          }}
          btnDisabled={!formState.isDirty}
          btnPending={isLoadingLinkPromo}
          btnText={t('profileData.buttonSave')}
          isActionVisible={!linkedPromo}
          title={t('profileData.partnerCode.title')}
      >
        <Grid>
          <Row>
            <Box>
              <TextInputContainer
                  control={control}
                  disabled={Boolean(linkedPromo)}
                  error={errorMessage}
                  hasError={isErrorLinkPromo || undefined}
                  name="partnerCode"
                  rules={{ required: t('defaultFormErrors.required') }}
                  title=""
              />
            </Box>
          </Row>
        </Grid>
      </WrapperDetails>
  );
};

export default PartnerCodeDetails;
